interface PropertyHiddenProps {
  value: any;
  onUpdate: (value: any) => void;
  configs: object;
  sourceElement?: object;
  internalState?: object;
  state: object;
}

export default function PropertyHidden({
  value,
  onUpdate,
  configs,
  sourceElement,
  internalState,
  state
}: PropertyHiddenProps) {
  return null;
}
